import { ActionReducerMap } from '@ngrx/store';
import { IWriteupsSharedState } from '..';

import { GetDealDetailsForInitiatedModalReducer } from './customer-info-reducer';

export const WriteupsSharedStateReducer: ActionReducerMap<IWriteupsSharedState> = {
    customerInfo:GetDealDetailsForInitiatedModalReducer
};
